<template>
  <div id="hres7de">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :unLoadBool="true"
            :columns="columns[app.nowLang].index"
            :receivedStore="receivedHres7deIndex"
            :editEvent="editEvent"
            searchBoxAlias="hres7de" />

    <detail v-show="detailDisp"
            :searchIndex="searchIndex"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :detail="detail"
            :codeval="codempid"
            :descCodeval="app.currentUser.username[app.nowLang]"
            :detailTab1PopupBtn1to3Columns="columns[app.nowLang].detailTab1PopupBtn1to3"
            :detailTab1PopupBtn4Columns="columns[app.nowLang].detailTab1PopupBtn4"
            :detailTab1Popup="detailTab1Popup"
            :receivedHres7deDetailTab1Popup="receivedHres7deDetailTab1Popup"
            :detailTab3MaxRowspan="maxRowspan.detailTab3"
            :detailTab3Columns="columns[app.nowLang].detailTab3"
            :detailTab3Selected="detailTab3Selected"
            :setDetailTab3Selected="setDetailTab3Selected"
            :detailTab3Popup="detailTab3Popup"
            :postHres7deTab2Save="postHres7deTab2Save"
            :postHres7deTab3PopupSave="postHres7deTab3PopupSave"
            :postHres7deTab4Save="postHres7deTab4Save"
            :receivedHres7deDetailTab3Popup="receivedHres7deDetailTab3Popup"
            :searchDetail="searchDetail" />
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as lovTypes from 'store/modules/hrmsLov/mutation-types'
import * as types from 'store/modules/hres7de/mutation-types'
import detail from 'components/hres7de/detail'
import moment from 'moment'

export default {
  name: 'hres7de',
  data () {
    return {
      searchIndex: {
        year: moment().format('YYYY'),
        courstrain: ''
      },
      searchDetail: {
        year: '',
        codcours: '',
        numclseq: ''
      },
      app: this.$parent.$parent.$parent
    }
  },
  watch: {
    'searchIndex.year' (newVal) {
      let params = newVal
      this.loadLovCourstrain(params)
    }
  },
  created () {
    this.receivedHres7deColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES7DE_INDEX_DISP,
      detailDisp: types.GET_HRES7DE_DETAIL_DISP,
      labels: types.GET_HRES7DE_LABELS,
      index: types.GET_HRES7DE_INDEX,
      maxRowspan: types.GET_HRES7DE_MAX_ROWSPAN,
      columns: types.GET_HRES7DE_COLUMNS,
      indexSelected: types.GET_HRES7DE_INDEX_SELECTED,
      detail: types.GET_HRES7DE_DETAIL,
      detailTab1Popup: types.GET_HRES7DE_DETAIL_TAB1_POPUP,
      detailTab3Selected: types.GET_HRES7DE_DETAIL_TAB3_SELECTED,
      detailTab3Popup: types.GET_HRES7DE_DETAIL_TAB3_POPUP,
      lov: lovTypes.GET_LOV
    })
  },
  methods: {
    loadLovCourstrain (params) {
      this.setLovCourstrain({ total: 0, rows: [], loading: false, finish: false })
      this.receivedLov({ lovType: 'COURSTRAIN', params: params })
    },
    pageDetail (event) {
      switch (event) {
        case 'edit':
          this.searchDetail = {
            year: this.searchIndex.year,
            codcours: this.indexSelected.codcours,
            numclseq: this.indexSelected.numclseq
          }
          if (this.indexSelected.numclseq) {
            this.receivedHres7deDetail(this.searchDetail)
            this.toggle('detail')
          }
          break
        default:
          break
      }
    },
    editEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail('edit')
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES7DE_INDEX_SELECTED,
      setDetailTab3Selected: types.SET_HRES7DE_DETAIL_TAB3_SELECTED,
      setLovCourstrain: lovTypes.SET_LOV_COURSTRAIN
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES7DE_PAGE,
      receivedHres7deColumnsLabels: types.RECEIVED_HRES7DE_COLUMNS_LABELS,
      receivedHres7deIndex: types.RECEIVED_HRES7DE_INDEX,
      postHres7deTab2Save: types.POST_HRES7DE_TAB2_SAVE,
      postHres7deTab3PopupSave: types.POST_HRES7DE_TAB3_POPUP_SAVE,
      postHres7deTab4Save: types.POST_HRES7DE_TAB4_SAVE,
      receivedHres7deDetail: types.RECEIVED_HRES7DE_DETAIL,
      receivedHres7deDetailTab1Popup: types.RECEIVED_HRES7DE_DETAIL_TAB1_POPUP,
      receivedHres7deDetailTab3Popup: types.RECEIVED_HRES7DE_DETAIL_TAB3_POPUP,
      receivedLov: lovTypes.RECEIVED_LOV
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?078fbefc